const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-new-store-locator'] = {
        c: () => require('partner/modules/dobbies-new-store-locator/dobbies-new-store-locator.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-new-store-locator',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-new-store-locator'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-new-store-locator|dobbies-new-store-locator'] = {
                c: () => require('partner/modules/dobbies-new-store-locator/dobbies-new-store-locator.view.tsx'),
                cn: '__local__-__local__-dobbies-new-store-locator'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };